import HomeView from './containers/HomeView'

// Sync route definition
export default {
  component : HomeView
}



// WEBPACK FOOTER //
// ./src/routes/Home/index.js